export default __webpack_public_path__ + "resources/icons/d342-8ea4.webp";